import React from 'react';
import { Table, Input, Button, Card, Row, Col } from 'antd';

const cardItems = [
  { key: 'raw', title: 'Raw Cal Qty', value: '200 Ton', valueColor: '#1451FF' },
  { key: 'pending', title: 'Pending Qty', value: '20 Ton', valueColor: '#1451FF' },
  { key: 'net', title: 'Net Qty', value: '220 Ton', valueColor: '#1451FF' },
  { key: 'add', title: 'Additional Qty', value: '0.0 Ton', valueColor: '#1451FF' },
];

const tableData = [
  { key: '01', material: 'Ragi', rawcalqty: '2.0', pendingqty: '+0.2 T', additionalqty: '', netqty: '2.02 T' },
  { key: '02', material: 'Ragi', rawcalqty: '2.0', pendingqty: '+0.2 T', additionalqty: '', netqty: '2.02 T' },
  { key: '03', material: 'Ragi', rawcalqty: '2.0', pendingqty: '+0.2 T', additionalqty: '', netqty: '2.02 T' },
  { key: '04', material: 'Ragi', rawcalqty: '2.0', pendingqty: '+0.2 T', additionalqty: '', netqty: '2.02 T' },
  { key: '05', material: 'Ragi', rawcalqty: '2.0', pendingqty: '+0.2 T', additionalqty: '', netqty: '2.02 T' },
  { key: '06', material: 'Ragi', rawcalqty: '2.0', pendingqty: '+0.2 T', additionalqty: '', netqty: '2.02 T' },
  { key: '07', material: 'Ragi', rawcalqty: '2.0', pendingqty: '+0.2 T', additionalqty: '', netqty: '2.02 T' },
];

const PO_MaterialTable = () => {
  const columns = [
    { title: 'S.No', dataIndex: 'key', key: 'key', align: 'center', width: 68 },
    { title: 'Material', dataIndex: 'material', key: 'material', align: 'center', width: 84 },
    { title: 'RAW CAL QTY', dataIndex: 'rawcalqty', key: 'rawcalqty', align: 'center', width: 116 },
    { title: 'PENDING QTY', dataIndex: 'pendingqty', key: 'pendingqty', align: 'center', width: 110 },
    {
      title: 'Additional QTY',
      dataIndex: 'additionalqty',
      key: 'additionalqty',
      align: 'center',
      width: 136,
      render: () => (
        <Input
          defaultValue="0.000"
          style={{
            width: 94,
            height: 34,
            background: '#F8FAFF',
            borderRadius: 7,
            textAlign: 'center',
            border: '1.2px solid #E5EAF5',
          }}
        />
      ),
    },
    { title: 'NET QTY', dataIndex: 'netqty', key: 'netqty', align: 'center', width: 98 },
  ];

  return (
    <div
      style={{
        background: '#F6F8FB',
        borderRadius: 16,
        maxWidth: 940,
        margin: '32px auto',
        padding: '27px 28px 24px',
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 10, gap: '75px' }}>
        <span style={{ fontWeight: 600, fontSize: 17 }}>MSPC NAME</span>
        <span style={{ fontWeight: 600, fontSize: 17 }}>Month : AUG</span>
      </div>

      {/* Cards */}
      <Row gutter={20} style={{ marginBottom: 18 }}>
        {cardItems.map((item) => (
          <Col key={item.key} xs={24} sm={12} md={6}>
            <Card
              bodyStyle={{
                padding: '13px 16px 10px 16px',
                minHeight: 56,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
              style={{
                borderRadius: 7,
                background: '#fff',
                border: 'none',
                boxShadow: '0 2.5px 7px rgba(121,123,141,0.10)',
              }}
            >
              <div
                style={{
                  fontSize: 15,
                  color: '#23282F',
                  fontWeight: 600,
                  marginBottom: 3,
                  letterSpacing: 0.05,
                  textAlign: 'left',
                }}
              >
                {item.title}
              </div>
              <div
                style={{
                  fontSize: 17,
                  color: item.valueColor,
                  fontWeight: 700,
                  textAlign: 'left',
                }}
              >
                {item.value}
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Table */}
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        showHeader
        bordered={false}
        size="small"
        rowKey="key"
        style={{
          background: '#fff',
          borderRadius: 10,
          border: 'none',
          marginBottom: 22,
        }}
      />

      {/* Buttons */}
      <div
        style={{
          display: 'flex',
          gap: 18,
          justifyContent: 'center',
          marginTop: 22,
        }}
      >
        <Button
          style={{
            borderRadius: 8,
            minWidth: 100,
            height: 36,
            fontWeight: 500,
            fontSize: 15,
            background: '#FAFBFC',
            border: '1.5px solid #C1C5CB',
            color: '#1B2336',
          }}
        >
          Back
        </Button>
        <Button
          type="primary"
          style={{
            borderRadius: 8,
            minWidth: 106,
            height: 36,
            fontWeight: 500,
            fontSize: 15,
            background: '#1451FF',
            border: 'none',
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default PO_MaterialTable;
